import React from "react";
import { useTranslation } from "react-i18next";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import SINGLE_USER_CONTEXT, { SingleUserProvider } from "src/context/internal/user";
import { BackButton } from "src/components/base/button";
import TabLayout from "src/components/base/tab-layout";
import { Tab, TabMenu } from "src/components/base/tab-menu";

/**
 * The properties for {@link SingleUser}
 */
export type SingleUserProps = {};

/**
 * The menu for a single user
 */
export default function SingleUser(props: SingleUserProps) {
    const [t] = useTranslation("customer-user-overview");

    const { userId } = Route.useParams();

    return (
        <SingleUserProvider uuid={userId}>
            <SINGLE_USER_CONTEXT.Consumer>
                {(ctx) => (
                    <div className={"flex flex-col gap-6"}>
                        <BackButton className={"self-start"} href={"/a/users"}>
                            {t("button.back-to-user-overview")}
                        </BackButton>
                        <TabLayout
                            heading={t("heading.user", { user: ctx.user.display_name })}
                            tabs={
                                <TabMenu>
                                    <Tab href={"/a/users/$userId/general"}>{t("label.general")}</Tab>
                                </TabMenu>
                            }
                        >
                            <Outlet />
                        </TabLayout>
                    </div>
                )}
            </SINGLE_USER_CONTEXT.Consumer>
        </SingleUserProvider>
    );
}
export const Route = createFileRoute("/_admin/a/users/$userId/_user")({
    component: SingleUser,
});
